import React from 'react';
import { Nav } from 'react-bootstrap';

import ThemeControlDropdown from 'components/navbar/top/ThemeControlDropdown';
import ExportDropdown from 'components/navbar/top/ExportDropdown';
import WarehouseDropdown from 'components/navbar/top/WarehouseDropdown';
import ProfileDropdown from 'components/navbar/top/ProfileDropdown';
import TenantDropdown from 'components/navbar/top/TenantDropdown';
import { useUserContext } from 'providers/UserProvider';
// import CartNotification from 'components/navbar/top/CartNotification';
// import NotificationDropdown from 'components/navbar/top/NotificationDropdown';
// import NineDotMenu from 'components/navbar/top/NineDotMenu';

const TopNavRightSideNavItem = () => {
  const { isSuperuser } = useUserContext();
  return (
    <Nav
      navbar
      className="navbar-nav-icons ms-auto flex-row align-items-center"
      as="ul"
    >
      {/*<CartNotification />*/}
      {/*<NotificationDropdown />*/}
      {/*<NineDotMenu />*/}
      {/*<ThemeControlDropdown />*/}
      <ExportDropdown />
      {isSuperuser && <TenantDropdown />}
      <WarehouseDropdown />
      <ProfileDropdown />
    </Nav>
  );
};

export default TopNavRightSideNavItem;
